import React from "react";
import styled from "styled-components";
import { useBladeHeaderContext } from "../context";
const StylableBladeHeaderTitle = ({ className, children, ...htmlProps }) => {
    useBladeHeaderContext("BladeHeaderTitle");
    return (React.createElement("div", { className: className, ...htmlProps }, children));
};
StylableBladeHeaderTitle.defaultProps = {
    "data-testid": "title",
};
export const BladeHeaderTitle = styled(StylableBladeHeaderTitle) ``;
//# sourceMappingURL=BladeHeaderTitle.js.map